import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type {
  DeleteClaimRequestDto,
  DeleteClaimResponseDto
} from "../../dtos/delete-claim-dto";
import { OrderService } from "../../services/order-service";

type UseDeleteClaimMutationProps = {
  options?: UseMutationOptions<
    DeleteClaimResponseDto,
    unknown,
    DeleteClaimRequestDto
  >;
};

export const useDeleteClaimMutation = ({
  options
}: UseDeleteClaimMutationProps = {}) => {
  return useMutation({
    mutationFn: async (payload) => await OrderService.deleteClaim({ payload }),
    ...options
  });
};
